import BackendError from './backend-error';

export default abstract class ClientError extends BackendError {
  public name = 'ClientError';
  constructor(message: string) {
    super(message);
  }
}
